<div>
  @if (sampleRequested !== undefined) {
    @if (sampleRequested === true) {
      <button mat-flat-button disabled class="button">Muster angefragt</button>
    } @else {
      @if (canOrderSample()) {
        <app-order-sample [productId]="this.productId"></app-order-sample>
      }
    }
  }
</div>
